import { render, staticRenderFns } from "./editions.vue?vue&type=template&id=f82bd174&scoped=true"
import script from "./editions.vue?vue&type=script&lang=js"
export * from "./editions.vue?vue&type=script&lang=js"
import style0 from "./editions.vue?vue&type=style&index=0&id=f82bd174&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82bd174",
  null
  
)

export default component.exports